import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useEffect, useRef, useCallback } from 'react';

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var isMounted = useRef(false);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }

    return function () {
      return undefined;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

function useDebounceFn(fn, deps, wait, disableAutoCancel) {
  // eslint-disable-next-line no-underscore-dangle
  var hooksDeps = Array.isArray(deps) ? deps : []; // eslint-disable-next-line no-underscore-dangle

  var hookWait = typeof deps === 'number' ? deps : wait || 0;
  var timer = useRef();
  var fnRef = useRef(fn);
  fnRef.current = fn;
  var cancel = useCallback(function () {
    if (disableAutoCancel) return;

    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);
  var run = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _len,
        args,
        _key,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args2[_key];
            }

            if (!(wait === 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", fnRef.current.apply(fnRef, args));

          case 3:
            return _context2.abrupt("return", new Promise(function (resolve) {
              cancel();
              timer.current = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fnRef.current.apply(fnRef, args);

                      case 2:
                        data = _context.sent;
                        resolve(data);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), hookWait);
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [wait, cancel, hookWait]);
  useUpdateEffect(function () {
    run();
    return cancel;
  }, [].concat(_toConsumableArray(hooksDeps), [run])); // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(function () {
    return cancel();
  }, []);
  return {
    run: run,
    cancel: cancel
  };
}

export default useDebounceFn;